import React from 'react';
import { Link } from "react-router-dom";

import tid_btn from 'img/tid-btn.svg';

export default function Materia({ data }) {

    const { desc, id_tid, is_TID6, avance } = data;

    const realPercentView = Math.ceil(avance);

    return (
        <React.Fragment>
            <li>
                <div className="li">
                    <div className="linea_an completa"></div>
                    <div className={is_TID6 ? "bola_ma" : "bola_ma sinTid"}></div> 
                    {is_TID6 ? 
                        <Link className="txt_ma" to={`/tid/${id_tid}`}>{desc}</Link>
                        :
                        <span className="txt_ma">{desc}</span>
                    }
                    
                    {is_TID6 ?
                        <Link className="desbt_ti" to={`/tid/${id_tid}`}><img src={tid_btn} alt="" /></Link>
                        : null
                    }
                    {is_TID6 &&
                        <div className={realPercentView === 100 ? 'avance gVerdeBg' : 'avance'} style={{ width: `${realPercentView}%` }}></div>
                    }
                </div>
            </li>

            {/* <li>
               {is_TID6 ? 
                <Link to={`/tid/${id_tid}`}>{str}</Link>
                : <span dataId={id}>{str}</span>
                }
            </li> */}
        </React.Fragment>
    );
}